import React from 'react';

interface Props {
  id?: string;
  bg?: string;
  children?: React.ReactNode;
}

const Container: React.FC<Props> = ({ id, children, bg }) => (
  <div id={id} className={`px-8 ${bg}`}>
    {children}
  </div>
);
Container.displayName = 'Layout.Container';

export default Container;
